<template>
  <div class="Crumbs" :class="[language == 'zh'?'zhFamily':'enfamily']">
      <div class="Crumbs_content">
          <span @click="toIndex()">{{$t('Articles.Home')}}</span>
      <i class="iconfont icon-jiantou2"></i>
      <!-- <div v-if="articlesData.channelName !='实时热点'">
          <span @click="toSecondary(articlesData.channelName)">{{articlesData.channelName}}</span>
              <i class="iconfont icon-jiantou2"></i>
      </div> -->
            
              <span class="active_">{{$t('Articles.Details')}}</span>

      </div>
  </div>
</template>

<script>
import { mapMixin } from "@/util/mixin";
export default {
  mixins: [mapMixin],
  props:['articlesData'],
  methods:{
    toIndex(){
      this.$router.push('/')
    },
    toSecondary(name){
      if (name == 'SDGs与社会') {
        this.$router.push(`/newslist?type=Society`);
      } else if (name == 'SDGs与科技') {
        this.$router.push(`/newslist?type=Technology`);
      }else if (name == '实践案例') {
        this.$router.push(`/newslist?type=Case`);
      }
        //  this.$router.push(`/newslist?type=${name}`)
    },
    toNews(){
       this.$router.push('/news')
    }
  }
}
</script>

<style lang="scss" scoped>
@media screen and (min-width: 1026px) {
  .Crumbs{
    width: 100%;
    height: 60px;
    background: rgba(10,16,75,1);
    .Crumbs_content{
      width: 1200px;
      height: 100%;
      margin: auto;
      display: flex;
      flex-direction: row;
      align-items: center;
      color:#fff;
      span{
        cursor: pointer;
        &:hover{
          color: #ccc;
        }
      }
      i{
        margin:  0 10px;
      }
      .active_{
        color: rgba(252,195,11,1);
      }
      // margin:  0 10px;
    }
  }
}
@media screen and (min-width: 768px) and (max-width: 1025px) {
    .Crumbs{
    width: 100%;
    height: 60px;
    background: rgba(10,16,75,1);
    .Crumbs_content{
      width: 1200px;
      height: 100%;
      margin: auto;
      display: flex;
      flex-direction: row;
      align-items: center;
      color:#fff;
      span{
        cursor: pointer;
        &:hover{
          color: #ccc;
        }
      }
      i{
        margin:  0 10px;
      }
      .active_{
        color: rgba(252,195,11,1);
      }
      // margin:  0 10px;
    }
  }
}
@media screen and (max-width: 767px) {
   .Crumbs{
    // width: 100%;
    padding: 10px;
    // height: 60px;
    background: rgba(10,16,75,1);
    .Crumbs_content{
      width: 100%;
      overflow: hidden;
      height: 100%;
      margin: auto;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      align-items: center;
      color:#fff;
      span{
        cursor: pointer;
        &:hover{
          color: #ccc;
        }
      }
      i{
        margin:  0 10px;
      }
      .active_{
        color: rgba(252,195,11,1);
      }
      // margin:  0 10px;
    }
  }
}
</style>